import area from '@turf/area';

const SQUARE_METERS_PER_ACRE = 4046.8564224;

export function getBlockArea(block) {
  if (!block || !block.bounds) {
    return 0;
  }
  const blockFeature = {
    id: block.id,
    type: 'Feature',
    geometry: block.bounds,
  };
  return area(blockFeature);
}

export function getRecommendationBlockAreaInMeterSquare(block) {
  const calculationAreaAcres = Number(block?.calculation_area_acres);
  if (Number.isFinite(calculationAreaAcres) && calculationAreaAcres > 0) {
    return calculationAreaAcres * SQUARE_METERS_PER_ACRE;
  }

  return getBlockArea(block);
}
